import {StepDatiGenFascicoloComponent} from '../../step-dati-gen-fascicolo/step-dati-gen-fascicolo.component';
import {StepPartiComponent} from "../../step-parti/step-parti.component";
import {StepSoggettiTerziComponent} from "../../step-soggetti-terzi/step-soggetti-terzi.component";
import {StepDatiEconomiciComponent} from "../../step-dati-economici/step-dati-economici.component";
import {StepAttiComponent} from "../../step-atti/step-atti.component";
import {StepAdempimentiComponent} from "../../step-adempimenti/step-adempimenti.component";
import {
  StepDocumentazioneAllegataComponent
} from "../../step-documentazione-allegata/step-documentazione-allegata.component";
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';

export let stepMap: Array<Accordions> = [];

// export let stepDatiGenerali: Accordions = {
//   context: NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO,
//   component: StepDatiGenFascicoloComponent,
//   customButtons: false,
//   properties: {title : "Dati Generali", id: "dati-generali", mandatory: true},
//   complete: false,
//   disabled: false
// };

export interface Accordions {
  context: string; 
  numeroStep?: number; 
  component: any; 
  isFascicoloWritable?: boolean;
  buttonLabel?: string; 
  customButtons?: boolean; 
  disabled: boolean;
  properties: {title: string; id: string; mandatory: boolean; [key: string]: any};
  complete: boolean;
}


export function getStepAccordionMapper() {
  return {
    "SezioneControparti": StepPartiComponent,
    "SezioneDatiEconomici": StepDatiEconomiciComponent,
    "SezioneAltreParti": StepSoggettiTerziComponent,
    "SezioneDocumentazioneAllegata": StepDocumentazioneAllegataComponent,
    "SezioneScadenze": StepAdempimentiComponent,
    "SezioneAtti": StepAttiComponent
  };
}
